import './../tab-navigation/tab-navigation.scss';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

class SubNavigation {
    constructor ($element) {
        this.$tabNavigation = $element;
        this.$tabNavigationSlider = this.$tabNavigation.querySelector('.tab-navigation__container');
        this.$tabItems = [];
        this.slider = null;
    }

    initialize () {
        this.initSlider();
        this.checkStickyness();
    }

    initSlider () {
        this.slider = new Swiper(this.$tabNavigationSlider, {
            modules: [Pagination],
            slidesPerView: 'auto',
            spaceBetween: 0,
            initialSlide: 0,
            speed: 1000,
            slideClass: 'tab-navigation__item',
            wrapperClass: 'tab-navigation__items',
            pagination: {
                el: '.tab-navigation__slider',
                type: 'progressbar'
            },
            on: {
                sliderMove: () => {
                    const $swiperSlider = this.$tabNavigation.querySelector('.tab-navigation__slider');
                    $swiperSlider.classList.add('is--active');
                },
                touchEnd: () => {
                    const $swiperSlider = this.$tabNavigation.querySelector('.tab-navigation__slider');
                    setTimeout(() => {
                        $swiperSlider.classList.remove('is--active');
                    }, 750);
                }
            }
        });
    }

    checkStickyness () {
        const $observedElement = document.querySelector('.tab-navigation__top');
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].intersectionRatio === 0) {
                this.$tabNavigation.classList.add('is--sticky');
            } else if (entries[0].intersectionRatio === 1) {
                this.$tabNavigation.classList.remove('is--sticky');
            }
        }, {
            threshold: [0, 1]
        });

        observer.observe($observedElement);
    }
}

export { SubNavigation };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $subNavigations = $context.querySelectorAll('[data-sub-navigation]');
        if ($subNavigations.length > 0) {
            $subNavigations.forEach((subNavigation) => {
                const $subNavigation = new SubNavigation(subNavigation);
                $subNavigation.initialize();
            });
        }
    }
});
